<template>
  <div class="ui container home">
    <div class="ui pointing secondary menu">
      <router-link class="item" to="/mm/cats">我的</router-link>
      <router-link class="item" to="/mm/stars">明星</router-link>
      <router-link class="item" to="/mm/users">用户</router-link>
      <router-link class="item" to="/mm/rank">排名</router-link>
      <router-link class="item" to="/mm/apply" v-if="account.isAdmin">申请</router-link>
<!--      <div class="ui right item">-->
<!--        <button class="ui button" :class="{disabled: run}" @click="discover">Discover</button>-->
<!--      </div>-->
    </div>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import auth from '@/services/Auth'
import EventBus from '@/services/event-bus'

export default {
  name: 'MmHome',
  data() {
    return {
      run: false,
      account: {},
    }
  },
  mounted () {
    this.account = auth.user;
    EventBus.$on('login', (data) => {
      this.account = data;
    });
  },
  methods: {
    discover() {
      axios.post('/admin/mm/discover').then(() => {
        this.run = true
        this.$toasted.show('discover')
      })
    }
  }
}
</script>

<style scoped>
.home {
  padding-bottom: 12px;
}
</style>
